import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { chatSettingsApi } from './chat-settings-api';

export const selectChatSettings = (state: RootState) => state.chatSettings;
export const selectChatSettingsAdditional = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.additional,
);
export const selectChatSettingsJurisdiction = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.jurisdiction,
);
export const selectChatSettingsMode = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.mode,
);
export const selectChatSettingsModels = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.models,
);
export const selectChatSettingsMainModel = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.mainModel,
);
export const selectChatSettingsThemeOptions = createSelector(
  selectChatSettings,
  (chatSettings) => chatSettings.themeOptions,
);
export const selectModesAndModelsResult =
  chatSettingsApi.endpoints.getModesAndModels.select();

const selectFileOptionsResult =
  chatSettingsApi.endpoints.getFileOptions.select();

export const selectFileOptions = createSelector(
  selectFileOptionsResult,
  (fileOptions) => fileOptions.data,
);
